import React from "react";
import "./index.scss";
import {strings} from "../../../../strings/strings";
import {SendContractToEmailForm} from "../../SendContractToEmailForm";
import {MtplQuotation} from "../../../../model/quotation";
import {ProductType} from "../../../../api/model/common";


interface EmtplCardSuccessfulQuotationViewProps {
    quotation: MtplQuotation
    type: ProductType
}

export const EmtplCardSuccessfulQuotationView = ({quotation, type}: EmtplCardSuccessfulQuotationViewProps) =>
    <div  className="successful-quotation__content__left__info">
        <h1>{strings.congrats}</h1>

        {!quotation.vtplAdditionalCoverage.covered && !quotation.cascoAdditionalCoverage.covered && (
            <p>{strings.successfulQuotationMTPL}</p>
        )}

        {quotation.vtplAdditionalCoverage.covered && !quotation.cascoAdditionalCoverage.covered && (
            <p>{strings.successfulQuotationMTPL_VTPL}</p>
        )}

        {!quotation.vtplAdditionalCoverage.covered && quotation.cascoAdditionalCoverage.covered && (
            <p>{strings.successfulQuotationMTPL_CASCO}</p>
        )}

        {quotation.vtplAdditionalCoverage.covered && quotation.cascoAdditionalCoverage.covered && (
            <p>{strings.successfulQuotationMTPL_VTPL_CASCO}</p>
        )}

        <p>
            {strings.successfulQuotation1}
            <span className={"accent"}>{quotation?.mtplContract.primaryInsured.email}</span>
            {strings.successfulQuotation2}
        </p>

        <SendContractToEmailForm  type={type} quotationId={quotation.id}/>

    </div>